import api from '.';

const API_URL = '/api/v1/manager/hyperfind';

/**
 * @returns {Promise<ApiManager.PublicHyperfindsResponse>}
 */
export const getAllMyPublicHyperfinds = () => api.get(`${API_URL}/public`);

/**
 * @param {number} hyperfindId
 * @param {moment.Moment} startDate
 * @param {moment.Moment} endDate
 * @returns {Promise<ApiManager.ExecuteHyperfindResponse>}
 */
// eslint-disable-next-line max-len
export const executeHyperfind = (hyperfindId, startDate, endDate) => api.get(`${API_URL}/execute/${hyperfindId}?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`);
